import { render, staticRenderFns } from "./entry_sjh_agree.vue?vue&type=template&id=4bf6f0f1&scoped=true"
import script from "./entry_sjh_agree.vue?vue&type=script&lang=js"
export * from "./entry_sjh_agree.vue?vue&type=script&lang=js"
import style0 from "./entry_sjh_agree.vue?vue&type=style&index=0&id=4bf6f0f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf6f0f1",
  null
  
)

export default component.exports